<nz-spin nzTip="Loading..." [nzSpinning]="bookingResource.isLoading()">
  <div class="flex flex-col gap-4 min-h-52">


    <div class="flex justify-between items-center">
      <button
        nz-button
        nzType="primary"
        [disabled]="visitAddFacade.isCompleted"
        (click)="changeSchedule()"
        >
        <i nz-icon nzType="calendar"></i>
        ჯავშნის ცვლილება
      </button>
      <button
        nz-button
        nzType="primary"
        [disabled]="visitAddFacade.isCompleted"
        (click)="addBooking()"
        >
        <i nz-icon nzType="plus"></i>
        ჯავშნის დამატება
      </button>
    </div>

    @for (booking of bookings(); track booking) {
      <div class="border border-[#EAE7E7] px-4 py-3 rounded-md">
        <div class="flex flex-col justify-between gap-2">
          @if (booking.room){
            <div nz-col class="flex gap-2">
              <div>
                <span class="text-xs font-semibold text-gray-500">ოთახი: </span>
                {{ booking.room?.name }}
              </div>
            </div>
          }
          <div class="flex-1" nz-row nzJustify="space-between">
            <div nz-col class="flex gap-2">
              <div>
                <span class="text-xs font-semibold text-gray-500">თანამშრომელი:</span>
                {{ booking.employee?.user?.fullName }}
              </div>
            </div>

            <div nz-col class="flex items-center gap-1">
              <i
                nz-icon
                nzType="field-time"
                nzTheme="outline"
                [style.color]="isInvalidTimeRange(booking) ? '#ff4d4f' : '#1890ff'"
              ></i>
              <span [class.text-red-500]="isInvalidTimeRange(booking)">
                {{ booking.startTime }} - {{ booking.endTime }}
              </span>
              @if (isInvalidTimeRange(booking)) {
                <nz-tag nzColor="error">
                  <i nz-icon nzType="warning"></i>
                  არასწორი დრო
                </nz-tag>
              }
            </div>
          </div>

          @if (booking.bookingServices && booking.bookingServices.length) {
            @for (bookingService of booking.bookingServices; track bookingService; let last = $last) {
              <div class="flex justify-between items-center gap-4">
                <div class="flex flex-col gap-2">
                  <div class="flex items-center gap-2">
                    <div
                      class="w-3 h-3 rounded-full"
                      [style.background-color]="bookingService?.service?.serviceCategory?.color || '#1890ff'"
                    ></div>
                    <div>{{ bookingService?.service?.name }}</div>
                    @if (bookingService?.offerPurchaseId) {
                      <nz-tag nzColor="gold" class="text-xs">
                        <i nz-icon nzType="gift" nzTheme="outline"></i>
                        {{ 'calendar.offerService' | translate }}
                      </nz-tag>
                    }
                    @if (bookingService?.packagePurchaseId) {
                      <nz-tag nzColor="cyan" class="text-xs">
                        <i nz-icon nzType="gift" nzTheme="outline"></i>
                        {{ 'calendar.packageService' | translate }}
                      </nz-tag>
                    }
                    @if (bookingService?.packageExpired) {
                      <nz-tag nzColor="error" class="text-xs">
                        <i nz-icon nzType="warning" nzTheme="outline"></i>
                        {{ 'calendar.packageExpired' | translate }}
                        @if (bookingService?.validUntil) {
                          ({{ bookingService.validUntil | date: 'yyyy-MM-dd' }})
                        }
                      </nz-tag>
                    }
                    @if (bookingService?.serviceDeleted) {
                      <nz-tag nzColor="error" class="text-xs">
                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                        {{ 'calendar.serviceDeleted' | translate }}
                      </nz-tag>
                    }
                    @if (bookingService?.serviceSource === 'OFFER' || bookingService?.serviceSource === 'BOOKINGHUB') {
                      <nz-tag nzColor="#db4e4e" class="text-xs">
                        <i nz-icon nzType="global" nzTheme="outline"></i>
                        BookingHub
                      </nz-tag>
                    }
                  </div>
                  <div class="flex items-center">
                    <ng-container *ngxPermissionsOnly="['field.employee_salary']">
                      <div>
                        @if (bookingService && bookingService.salaryPercent) {
                          <nz-tag nzColor="default">{{ bookingService.salaryPercent }}%</nz-tag>
                        }
                        @if (bookingService && bookingService.salaryFixed) {
                          <nz-tag nzColor="default">{{ bookingService.salaryFixed }}
                            <i class="lari lari-c"></i>
                          </nz-tag>
                        }
                      </div>
                    </ng-container>
                    <div>
                      <i
                        nz-icon
                        nzType="field-time"
                        nzTheme="outline"
                        style="color: #1890ff"
                      ></i>
                      {{ bookingService?.time }}
                    </div>
                    <nz-divider nzType="vertical"></nz-divider>
                    <div class="flex gap-1 items-center">
                      @if (+bookingService?.salePrice > 0) {
                        <div class="flex items-center gap-1">
                          <i
                            nz-icon
                            nzType="money-collect"
                            nzTheme="outline"
                            style="color: #1890ff"
                          ></i>
                          <div>
                            {{ bookingService.salePrice }} <i class="lari lari-c"></i>
                          </div>
                          <del>{{ bookingService.price }} <i class="lari lari-c"></i></del>
                        </div>
                      }
                      @if (+bookingService.salePrice <= 0) {
                        <div>
                          <i
                            nz-icon
                            nzType="money-collect"
                            nzTheme="outline"
                            style="color: #1890ff"
                          ></i>
                          {{ bookingService.price }} <i class="lari lari-c"></i>
                        </div>
                      }
                    </div>

                    @if (bookingService.serviceProducts && bookingService.serviceProducts.length) {
                      <nz-divider nzType="vertical"></nz-divider>
                      <i
                        nz-icon
                        nzType="shopping-cart"
                        nzTheme="outline"
                        style="color: #1890ff"
                      ></i>
                      {{ bookingService.serviceProducts.length }}
                    }

                  </div>
                </div>
                <nz-space [nzSize]="16">
                  <button
                    *nzSpaceItem
                    (click)="agreement(booking.id, bookingService.service.id)"
                    nz-button
                    nzType="default"
                    nzShape="circle"
                    [disabled]="visitAddFacade.isCompleted"
                    nz-tooltip="თანხმობის დამატება"
                    >
                    <nz-icon nzType="signature" nzTheme="outline" />
                  </button>
                  @if (visitAddFacade.isCompleted) {
                    <button
                      *nzSpaceItem
                      (click)="viewBookingService(booking, bookingService)"
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      nz-tooltip="პროცედურის ნახვა"
                      >
                      <nz-icon nzType="eye" />
                    </button>
                  } @else {
                    <button
                      *nzSpaceItem
                      (click)="editBookingService(booking, bookingService)"
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      nz-tooltip="პროცედურის რედაქტირება"
                      >
                      <nz-icon nzType="edit" />
                    </button>
                  }
                  @if (visitAddFacade.status !== 2) {
                    <button
                      *nzSpaceItem
                      nz-popconfirm
                      nzPopconfirmTitle="დარწმუნებული ხართ, რომ გსურთ პროცედურის წაშლა?"
                      (nzOnConfirm)="deleteBookingService(bookingService)"
                      nz-button
                      nzDanger
                      nzType="dashed"
                      nzShape="circle"
                      [disabled]="visitAddFacade.isCompleted"
                      nz-tooltip="პროცედურის წაშლა"
                      >
                      <nz-icon nzType="delete" />
                    </button>
                  }
                </nz-space>
              </div>

              @if (bookingService?.specServices && bookingService?.specServices?.length) {
                <div nz-row nzJustify="space-between" nzAlign="bottom" style="margin-top: 10px">
                  <div nz-col nzFlex="90%">
                    @for (specService of bookingService.specServices; track specService) {
                      <nz-tag
                        [nzColor]="'blue'"
                        style="margin-top: 2px"
                        >
                        {{ specService?.service?.name }}
                      </nz-tag>
                    }
                  </div>
                </div>
              }
              @if (bookingService.additionalEmployees && bookingService.additionalEmployees.length > 0){
                <div>
                  <div
                    class="text-xs font-semibold text-gray-500"
                  >დამატებითი თანამშრომელი:</div>

                  <div class="flex items-center gap-1">
                    @for (additionalEmployee of bookingService.additionalEmployees || []; track $index) {
                      <div class="flex items-center gap-1">
                        <div class="flex items-center gap-1">
                          {{ additionalEmployee?.employee?.user?.fullName }}
                        </div>
                        <div>
                          @if (additionalEmployee.salaryFixed) {
                            <nz-tag nzColor="default">{{ additionalEmployee.salaryFixed }}
                              <i class="lari lari-c"></i>
                            </nz-tag>
                          } @else {
                            <nz-tag nzColor="default"> {{ additionalEmployee.salaryPercent }}% </nz-tag>
                          }
                        </div>
                        @if ($index < bookingService.additionalEmployees.length - 1) {
                          <nz-divider nzType="vertical"></nz-divider>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              @if (!bookingService.salaryPercent && !bookingService.salaryFixed) {
                <div
                  class="text-xs font-semibold px-4 py-2 rounded-md bg-yellow-100 text-yellow-600 border border-yellow-500"
                  >
                  პროცედურაში არ არის მითითებული ხელფასის პროცენტი ან ფიქსირებული
                </div>
              }
              <nz-divider [nzDashed]="true" size="small"></nz-divider>
            }

          } @else {
            <div
              class="flex justify-between items-center text-xs font-semibold px-4 py-2 rounded-md bg-yellow-100 text-yellow-600 border border-yellow-500">
              <div>
                პროცედურა არ არის მითითებული
              </div>

              <button nz-button nzType="primary" (click)="addBookingService(booking)">
                დამატება
              </button>
            </div>

          }
          @if (booking.latestComment?.text || booking.description) {
            <div
              class="text-xs font-semibold px-4 py-2 rounded-md bg-blue-50 text-primary-500 border border-blue-100 flex justify-between items-start"
              >
              <div class="flex-1">
                @if (booking.latestComment?.isPinned) {
                  <span nz-icon nzType="pushpin" nzTheme="fill" style="color: #1890ff;" class="mr-1"></span>
                }
                {{ booking.latestComment?.text || booking.description }}
              </div>
              @if (booking.commentCount > 0) {
                <span class="ml-2 shrink-0 text-xs text-blue-400">({{ booking.commentCount }})</span>
              }
            </div>
          }

          @if (fastCommentBookingId() === booking.id) {
            <div class="flex items-center gap-2">
              <nz-input-group [nzSuffix]="fastCommentSuffix" class="flex-1">
                <textarea
                  nz-input
                  [(ngModel)]="fastCommentText"
                  (keydown.control.enter)="submitFastComment(booking.id)"
                  placeholder="{{ 'visitComments.placeholder' | translate }}"
                  [disabled]="fastCommentSubmitting()"
                  [nzAutosize]="{ minRows: 1, maxRows: 4 }"
                ></textarea>
              </nz-input-group>
              <ng-template #fastCommentSuffix>
                <button
                  nz-button
                  nzType="text"
                  nzSize="small"
                  [nzLoading]="fastCommentSubmitting()"
                  [disabled]="!fastCommentText.trim()"
                  (click)="submitFastComment(booking.id)"
                  >
                  <span nz-icon nzType="send" nzTheme="outline"></span>
                </button>
              </ng-template>
            </div>
          }

          <div class="flex justify-between items-center gap-4">
            <nz-space [nzSize]="16">

              <button
                *nzSpaceItem
                (click)="addBookingService(booking)"
                nz-button
                nzType="default"
                nzShape="circle"
                [disabled]="visitAddFacade.isCompleted"
                nz-tooltip="პროცედურის დამატება"
                >
                <nz-icon nzType="plus" />
              </button>
              <button
                *nzSpaceItem
                (click)="editBooking(booking)"
                nz-button
                nzType="default"
                nzShape="circle"
                [disabled]="visitAddFacade.isCompleted"
                nz-tooltip="ჯავშნის ცვლილება"
                >
                <nz-icon nzType="calendar" />
              </button>
              <button
                *nzSpaceItem
                (click)="toggleFastComment(booking.id)"
                nz-button
                nzType="default"
                nzShape="circle"
                [disabled]="visitAddFacade.isCompleted"
                nz-tooltip="კომენტარის დამატება"
                >
                <nz-icon nzType="comment" />
              </button>
              <ng-container *ngxPermissionsOnly="['Admin', 'Manager']">
                <button
                  *nzSpaceItem
                  (click)="viewBookingHistory(booking.id)"
                  nz-button
                  nzType="default"
                  nzShape="circle"
                  nz-tooltip="ჯავშნის ისტორია"
                >
                  <nz-icon nzType="history" />
                </button>
              </ng-container>
              @if (visitAddFacade.status !== 2) {
                <button
                  *nzSpaceItem
                  nz-popconfirm
                  nzPopconfirmTitle="დარწმუნებული ხართ, რომ გსურთ ჯავშნის წაშლა?"
                  (nzOnConfirm)="deleteBooking(booking.id)"
                  nz-button
                  nzDanger
                  nzType="dashed"
                  nzShape="circle"
                  [disabled]="visitAddFacade.isCompleted"
                  nz-tooltip="ჯავშნის წაშლა"
                  >
                  <nz-icon nzType="delete" />
                </button>
              }
            </nz-space>
            <nz-space [nzSize]="16">
              @if (booking.latestComment?.text || booking.description) {
                <div *nzSpaceItem class="flex items-center gap-1">
                  @if (booking.latestComment?.isPinned) {
                    <i nz-icon nzType="pushpin" nzTheme="fill" style="color: #1890ff;"></i>
                  }
                  <i
                    nz-icon
                    nzType="comment"
                    nzTheme="outline"
                    [nz-tooltip]="booking.latestComment?.text || booking.description"
                    style="color: #1890ff; font-size: 16px; cursor: pointer;"
                  ></i>
                  @if (booking.commentCount > 0) {
                    <span class="text-xs text-blue-400">({{ booking.commentCount }})</span>
                  }
                </div>
              }
              <div *nzSpaceItem>
                <button (click)="agreementView(booking.userAgreements)" class="text-[12px] text-gray-500"
                  nz-tooltip="თანხმობის ნახვა"
                  >
                  {{ booking.userAgreements.length }} თანხმობა
                </button>
              </div>
              <!--            <button-->
              <!--              *nzSpaceItem-->
              <!--              (click)="deleteBooking(booking)"-->
              <!--              nz-button-->
              <!--              nzSize="small"-->
              <!--              nzType="default"-->
              <!--              [disabled]="visitAddFacade.isCompleted"-->
              <!--            >-->
              <!--              <i nz-icon nzType="upload"></i>-->
              <!--              ატვირთვა-->
            <!--            </button>-->
          </nz-space>
        </div>
      </div>
    </div>
  }

</div>
</nz-spin>
